import React from 'react';
import useGroupWithPools from 'features/SpilKlub/state/useGroupWithPools';
import Pools from 'features/SpilKlub/components/Pools';
import PoolListHeader from 'features/SpilKlub/components/PoolListHeader';
import Spinner from '../../../ecoui/UISpinner';
import * as UiActions from 'actions/UiActions';
import { detectMobile } from '../../../utils/UiHelper';

import '../styles/pools.css';
import { authHandler } from '../index';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

const PoolList = ({ entityId: groupId, uiActions }) => {
    const { data, status, error, isGroupOwner } = useGroupWithPools({
        groupId,
        authHandler: () => authHandler(uiActions),
    });

    return (
        <div className={'sk-pools-page-wrapper'}>
            {status === 'loading' ? (
                <Spinner className="top-indent-md" />
            ) : status === 'error' ? null : (
                <>
                    <PoolListHeader
                        group={data?.group}
                        isGroupOwner={isGroupOwner}
                    />

                    {detectMobile() ? <hr color={'#EDEFF4'} size={1} /> : null}

                    <Pools pools={data} />
                </>
            )}
        </div>
    );
};

function mapDispatchToProps(dispatch) {
    return {
        uiActions: bindActionCreators(UiActions, dispatch),
    };
}

export default connect(
    null,
    mapDispatchToProps
)(PoolList);
